import { Component } from '@angular/core';

@Component({
  selector: 'app-services-section3',
  templateUrl: './services-section3.component.html',
  styleUrls: ['./services-section3.component.scss']
})
export class ServicesSection3Component {}
